import { useRouteMatch } from "react-router";

export const useIsPath = (path: string): boolean => {
  const matchedRoute = useRouteMatch(path);

  return matchedRoute?.isExact ?? false;
};
